<template lang="pug">
v-container(
  fluid
  :class="$vuetify.breakpoint.mobile ? 'tw-h-auto tw-overflow-y-auto' : 'tw-h-full tw-overflow-hidden'"
  class="tw-rounded tw-pt-0 tw-pb-0"
  :style="$vuetify.breakpoint.mobile ? 'background: #f5f5fa; max-height: calc(100vh - 128px)' : 'background: #f5f5fa'"
)
  div(:class="$vuetify.breakpoint.mobile ? 'tw-flex tw-flex-col tw-h-auto tw-pb-0' : 'tw-flex tw-flex-col tw-h-full tw-pb-0'")
    div(class="tw-flex tw-flex-row tw-bg-white tw-rounded-md tw-px-3")
      v-row(justify="end")
        v-col(cols="auto")
          v-btn(depressed color="rgba(94,129,244,0.80)" @click="addListingDialogToggle")
            span(class="tw-font-bold") {{ $t('Listings.Common.addListing') }}
    div(
      :class="$vuetify.breakpoint.mobile ? 'tw-flex tw-flex-col tw-justify-between tw-h-auto tw-overflow-visible tw-pt-2 tw-pb-12 tw-bg-white tw-mt-4 tw-mb-2 tw-rounded-md' : 'tw-flex tw-flex-col tw-justify-between tw-h-full tw-overflow-hidden tw-pt-2 tw-pb-12 tw-bg-white tw-mt-4 tw-mb-2 tw-rounded-md'"
    )
      v-row(no-gutters :class="$vuetify.breakpoint.mobile ? 'tw-h-auto pb-4 mb-0' : 'tw-h-full pb-4 mb-0'")
        v-col(
          cols="12"
          md="2"
          :class="$vuetify.breakpoint.mobile ? 'pa-0 ma-0 tw-h-auto tw-overflow-visible' : 'pa-0 ma-0 tw-h-full tw-overflow-auto'"
        )
          kubiqa-goods-search-filters
        v-col(:class="$vuetify.breakpoint.mobile ? 'tw-h-auto' : 'tw-h-full'")
          div(:class="$vuetify.breakpoint.mobile ? 'tw-flex-col tw-overflow-visible tw-h-auto' : 'tw-flex-col tw-overflow-scroll tw-h-full'")
            template(v-if="loading")
              div(class="tw-flex tw-flex-col tw-w-full tw-h-full tw-overflow-hidden")
                v-row(align="center" justify="center" class="tw-h-full")
                  v-col(cols="auto" class="tw-opacity-50")
                    v-lottie-player(
                      :loop="true"
                      width="300px"
                      :animation-data="require('@/assets/animations/loading.json')"
                    )
            template(v-if="properties && properties.length > 0 && !loading")
              div(class="tw-flex tw-flex-wrap  tw-px-6 pt-2  tw-justify-start " :key="mKey")
                kubiqa-goods-preview-card(v-for="property in properties" :key="property.id" :item="property" class="tw-pl-4")
            template(v-else-if="properties && properties.length == 0 && !loading")
              div(class="tw-w-full tw-flex tw-items-center tw-justify-center tw-text-center" :style="$vuetify.breakpoint.mobile ? 'min-height: 16rem' : 'height: 100%'")
                kubiqa-misc-empty-state(
                  :title="$t(hasListingFilters ? 'Common.emptyStates.noMatchesTitle' : 'Common.emptyStates.noListingsTitle')"
                  :description="$t(hasListingFilters ? 'Common.emptyStates.noMatchesBody' : 'Common.emptyStates.noListingsBody')"
                  icon="mdi-home-search-outline"
                )
      v-row(no-gutters justify="center" align="start" class="mt-0 tw-pt-0 tw-w-full  ")
        v-col(cols="5" class="tw-mb-0 mt-0 ")
          template(v-if="this.$store.getters['properties/searchResultsTotal'] > 1")
            v-pagination(
              v-model="paginationCurrent"
              :length="paginationTotal"
              @input="paginate"
              circle
              elevation="0"
              small
              color="#5e81f4cc"
            )
  v-dialog(v-model="addListingDialog" max-width="75%")
    div(class="tw-bg-white add-listing-modal")
      kubiqa-goods-add(:key="mKey" @close="addListingDialogToggle")
</template>
<script>
export default {
  data() {
    return {
      addListingDialog: false,
      mKey: 1,
      paginationCurrent: 1,
    };
  },
  computed: {
    properties() {
      return this.$store.getters['properties/searchResults'];
    },
    loading() {
      //return true;
      return this.$store.getters['properties/loading'];
    },
    // paginationCurrent() {
    //   return this.$store.getters['properties/searchResultsCurrentPage'];
    // },
    paginationTotal() {
      return this.$store.getters['properties/searchResultsTotal'];
    },
    hasListingFilters() {
      const query = this.$store.getters['properties/query'];
      if (!query || !query.keys) return false;
      return Array.from(query.keys()).some((key) => key !== 'page');
    },
  },
  created() {
    this.$store.commit('displaySidebar', true);
    this.$store.commit('displayWebsiteToolbar', false);
    this.$store.commit('displayMainToolbar', true);
  },
  async mounted() {
    // if (!this.$store.getters['properties/searchResults'] && !this.$store.getters['properties/query']) {
    //   let query = new URLSearchParams();
    //   this.$store.dispatch('properties/search', query);
    // }
    this.loading = true;
    let query = new URLSearchParams();
    await this.$store.dispatch('properties/search', query).then((response) => {
      this.loading = false;
    });
  },
  methods: {
    addListingDialogToggle() {
      this.mKey = ++this.mKey;
      return (this.addListingDialog = !this.addListingDialog);
    },
    paginate() {
      let query = this.$store.getters['properties/query'];
      query.delete('page');
      query.append('page', this.paginationCurrent);
      this.$store.dispatch('properties/search', query);
    },
  },
};
</script>

<style lang="css">
.add-listing-modal {
  height: 80vh !important;
  max-height: 600px;
}

.v-pagination__item,
.v-pagination__navigation {
  box-shadow: none !important;
  border: 1px solid #f3f3f3;
}
</style>
